// extracted by mini-css-extract-plugin
export default {"message":"auto-login_message__8efde"};